// src/components/Footer.js
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { FloatingContactContext } from './FloatingContact'; // Import the context
import '../styles/Footer.css';
import env from '../config/env'; // Import environment config

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { handleOpenContact } = useContext(FloatingContactContext); // Get the contact handler
  
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-logo-section">
            <Link to="/" className="footer-logo-link">
              {/* Use the WHITE logo URL from the config for the footer */}
              <img 
                src={env.footerLogoUrl} 
                alt="Legate" 
                className="footer-logo"
              />
            </Link>
            <p className="footer-tagline">Entrepreneurship Is Our Freedom</p>
            <div className="footer-social">
              {/* Updated social media links - replace with actual Legate profiles */}
              <a href="https://www.facebook.com/profile.php?id=61552154247759" target="_blank" rel="noopener noreferrer" className="social-link">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="https://x.com/LegateBiz" target="_blank" rel="noopener noreferrer" className="social-link">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="https://linkedin.com/company/legate-consulting" target="_blank" rel="noopener noreferrer" className="social-link">
                <i className="fab fa-linkedin-in"></i>
              </a>
              <a href="https://instagram.com/legatebusinessformation" target="_blank" rel="noopener noreferrer" className="social-link">
                <i className="fab fa-instagram"></i>
              </a>
            </div>
          </div>
          
          <div className="footer-links-section">
            <div className="footer-links-column">
              <h3 className="footer-heading">Quick Links</h3>
              <ul className="footer-links">
                <li><Link to="/">Home</Link></li>
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/services">Services</Link></li>
                <li><Link to="/blog">Blog</Link></li>
                <li><button onClick={handleOpenContact} className="text-link">Contact</button></li>
              </ul>
            </div>
            
            <div className="footer-links-column">
              <h3 className="footer-heading">Services</h3>
              <ul className="footer-links">
                <li><Link to="/services#llc">Business Formation</Link></li>
                <li><Link to="/services#consulting">Strategic Consulting</Link></li>
                <li><Link to="/services#compliance">Compliance Solutions</Link></li>
                <li><Link to="/services#tax">Tax Planning</Link></li>
                <li><Link to="/services#growth">Growth Strategies</Link></li>
              </ul>
            </div>
            
            <div className="footer-links-column">
              <h3 className="footer-heading">Contact</h3>
              <ul className="footer-contact-info">
                <li>
                  <i className="fas fa-map-marker-alt"></i>
                  <span>999 3rd St Suite 700<br />Seattle, WA 98104</span>
                </li>
                <li>
                  <i className="fas fa-phone"></i>
                  <span>‪(206) 627-0484‬</span>
                </li>
                <li>
                  <i className="fas fa-envelope"></i>
                  <span>legate@legatebusiness.com</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p className="copyright">
            &copy; {currentYear} Legate Consulting. All Rights Reserved.
          </p>
          <div className="footer-legal-links">
            <Link to="/terms">Terms of Service</Link>
            <Link to="/privacy">Privacy Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
